<template>
    <Breadcrumbs main="Bonus Ui" title="Ribbons" />
    <div class="container-fluid">
        <leftRibbons />
        <rightRibbons />
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const leftRibbons = defineAsyncComponent(() => import("@/components/theme/advance/ribbons/leftRibbons.vue"))
const rightRibbons = defineAsyncComponent(() => import("@/components/theme/advance/ribbons/rightRibbons.vue"))
</script>